import { Chip, Paper, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { resolveTokens } from '@/theme';

export interface KpiTileProps {
  label: string;
  value: string;
  note?: string;
  tag?: string;
  emphasis?: boolean;
}

export function KpiTile({ label, value, note, tag, emphasis }: KpiTileProps) {
  const tokens = resolveTokens(useTheme());
  return (
    <Paper sx={{ p: 2, height: '100%' }}>
      <Typography variant="overline" component="p" sx={{ color: tokens.text2 }}>
        {label}
      </Typography>
      <Typography
        variant="kpi"
        component="p"
        sx={{
          color: emphasis ? tokens.brand : tokens.text,
          display: 'inline',
        }}
      >
        {value}
      </Typography>
      {tag ? (
        <Chip
          size="small"
          label={tag}
          sx={{
            marginInlineStart: 1,
            verticalAlign: 'middle',
            bgcolor: tokens.brandSoft,
            color: tokens.text2,
          }}
        />
      ) : null}
      {note ? (
        <Typography variant="caption" component="p" sx={{ color: tokens.text2, display: 'block', mt: 0.25 }}>
          {note}
        </Typography>
      ) : null}
    </Paper>
  );
}
